import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PlayableService } from 'src/app/model/playable/playable.service';

@Component({
  selector: 'fgb-arcade-page',
  templateUrl: './arcade-page.component.html',
  styleUrl: './arcade-page.component.scss',
})
export class ArcadePageComponent implements OnInit {
  matchEmAllURL: string;
  shuffleConeURL: string;
  flappyGullyURL: string;
  mitomaMagicURL: string;
  snakeURL: string;

  private _destroyed$ = new Subject<void>();

  constructor(private playableService: PlayableService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.matchEmAllLink();
    this.shuffleConeLink();
    this.flappyGullyLink();
    this.mitomaMagicLink();
    this.snakeLink();
  }

  launchGame(url: string) {
    this.playableService.sso(1, url);
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  matchEmAllLink() {
    this.translate
      .stream('matchEmAll.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.matchEmAllURL = data;
      });
  }

  shuffleConeLink() {
    this.translate
      .stream('shuffleCone.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.shuffleConeURL = data;
      });
  }

  flappyGullyLink() {
    this.translate
      .stream('flappyGully.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.flappyGullyURL = data;
      });
  }

  mitomaMagicLink() {
    this.translate
      .stream('mitomaMagic.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.mitomaMagicURL = data;
      });
  }

  snakeLink() {
    this.translate
      .stream('snake.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.snakeURL = data;
      });
  }
}
